<!--Footer Starts-->
<footer class="footer">
  <p class="copyright text-center">
    Copyright  &copy;  {{currentDate | date: 'yyyy'}} <a id="celeritas" href="https://www.als.com.uy/">ALS IT</a>, All rights reserved. {{getVersion()}}
  </p>
</footer>
<!--Footer Ends-->
